var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #9ca9ba;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #bfcbdc;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #d1def0;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #adb9c8;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #535a63;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #e9f3ff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.5,86.3c2.2-3.1,3.8-6.6,4.7-10.6,2.8-14.7-6.6-28.8-21.3-31.6-14.7-2.8-28.8,6.6-31.6,21.3-.9,4.1-.6,7.8,0,11.6l47.9,9.7h0l.3-.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.7,60.3c-2.5,0-5.9,0-10.3-1.3-9.1-2.5-18.8-10-27.2-12.5-6.3,3.4-11,9.1-13.1,16.3,3.1-1.6,7.2-3.1,12.8-3.4,12.2-.6,24.7,5.3,31.6,6.3,3.1.3,5.6,0,7.8-.6-.3-1.6-.9-3.4-1.6-5h0v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85,76.9c-4.4-.9-17.8-11.9-31-11.3-7.2,0-12.2,1.6-15,2.8,0,2.8,0,5.6.6,8.4l47.9,9.7c2.2-2.8,3.8-6.3,4.4-10.3-2.2.6-5,1.3-7.2.9h0l.3-.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.4,22.5h0c0,.6-.6.9-1.3,1.3.6,0,.9.6,1.3,1.3h0c0-.6.6-.9,1.3-1.3-.6,0-.9-.6-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.7,12.1h0c0,.6-.6.9-1.3,1.3.6,0,.9.6,1.3,1.3h0c0-.6.6-.9,1.3-1.3-.6,0-.9-.6-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.9,35h0c0,.6-.6.9-1.3,1.3.6,0,.9.6,1.3,1.3h0c0-.6.6-.9,1.3-1.3-.6,0-.9-.6-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.2,59.4h0c0,.6-.6.9-1.3,1.3.6,0,.9.6,1.3,1.3h0c0-.6.6-.9,1.3-1.3-.6,0-.9-.6-1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.1,16.5h0c-.3,1.3-1.3,2.2-2.2,2.5,1.3.6,1.9,1.3,2.2,2.5h0c.3-1.3,1.3-2.2,2.2-2.5-1.3-.6-1.9-1.3-2.2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.3,50.3h0c-.3,1.3-1.3,2.2-2.2,2.5,1.3.6,1.9,1.3,2.2,2.5h0c.3-1.3,1.3-2.2,2.2-2.5-1.3-.6-1.9-1.3-2.2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,10.9h0c-.3,1.3-1.3,2.2-2.2,2.5,1.3.6,1.9,1.3,2.2,2.5h0c.3-1.3,1.3-2.2,2.2-2.5-1.3-.6-1.9-1.3-2.2-2.5Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 62.5,
    cy: 16.8,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.4,7.1c0,1.6,0,3.1-.6,4.1-1.3,2.5-3.1,3.4-7.5,5.6s-2.5,2.5-2.8,4.1c.6,1.6,1.9,2.8,3.1,3.8,0-1.3.9-2.5,1.9-3.8,2.5-2.8,6.6,0,11.3-2.5,1.3-.6,1.9-1.6,2.5-2.8-.6-4.4-3.8-7.8-7.8-8.4h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 15.9,
    cy: 41.2,
    r: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.7,48.4c-.6,0-1.3,0-1.3-.6s0-1.3,1.3-2.2c.9-.9,2.5-1.9,4.4-2.8h0c-1.9.9-3.4,1.9-4.4,2.8-1.3,1.3-1.3,1.6-1.3,1.6,0,0,.6.6,4.4-.3,2.8-.6,6.3-1.9,10-3.8,3.8-1.6,7.2-3.4,9.4-5,3.4-2.2,3.4-3.1,3.4-3.1,0,0-.3-.3-1.9,0-1.3,0-2.8.6-5,1.3h0c1.9-.6,3.8-.9,5-1.3,1.3,0,2.2,0,2.5.3,0,.3,0,.9-.6,1.6s-1.6,1.3-2.8,1.9c-2.5,1.6-5.9,3.4-9.4,5s-7.2,2.8-10,3.8c-1.3.3-2.5.6-3.4.6h-.3v.3Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.5,92.9c-13.1-11.6-30.4-18.8-49.1-18.8S13.4,81.3.2,92.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.5,93.2h0c-3.1-2.8-6.9-5.6-10.3-7.8-3.8-2.2-7.8-4.4-11.9-5.9-8.4-3.4-17.5-5-26.6-5s-18.1,1.6-26.6,5c-4.1,1.6-8.1,3.4-11.9,5.9-3.8,2.2-7.2,5-10.3,7.8h0c3.1-2.8,6.9-5.6,10.6-7.8,3.8-2.2,7.8-4.4,11.9-5.9,8.4-3.4,17.5-5,26.9-5s18.1,1.6,26.9,5c4.1,1.6,8.1,3.8,11.9,5.9,3.8,2.2,7.2,5,10.6,7.8h-1.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.4,87.2v-3.1s4.1-4.4,8.8-6.9c8.1-4.7,12.5-4.1,12.5-4.1l5.9,2.5s-3.8,5.3-11.6,9.4c-5.6,2.8-10.6,4.1-10.6,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.5,89.1h0s5-1.3,10.3-4.1c4.1-1.9,6.9-4.4,8.8-6.3s2.5-2.5,2.8-3.1l-5.6-2.2h-3.1c-3.4.6-6.9,2.5-9.1,3.8-4.4,2.5-8.1,6.6-8.8,6.9v2.8h0v-3.1h0s4.1-4.4,8.8-7.2c2.5-1.3,5.9-3.1,9.4-3.8,2.2-.3,3.1,0,3.1,0h0l5.9,2.5h0s-.9,1.3-2.8,3.1c-1.9,1.6-4.7,4.1-8.8,6.3-5.6,2.8-10.6,4.1-10.6,4.1h0l-.3.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M9.9,84.4h0s1.3-.6,7.2-3.1c5.9-2.8,8.1-5.3,8.1-5.3h0s-.6.6-1.9,1.6-3.4,2.2-6.6,3.8c-5.9,2.8-7.2,3.1-7.2,3.1h.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.8,75.3s4.4-1.3,5-1.3c1.9,0,4.7.3,11.6,3.4,6.6,3.1,10.6,6.6,10.6,6.6l2.5,3.8s-6.3.9-15-2.5-13.1-7.2-13.1-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.4,88.2h-2.5c-2.5,0-6.3-.9-11-2.5-2.5-.9-6.3-2.5-9.7-4.7-2.2-1.3-3.1-2.2-3.4-2.2h0s1.3.9,3.1,2.2c1.9,1.3,5.3,3.1,9.7,4.7,4.4,1.9,8.4,2.2,10.6,2.5h4.1l-2.2-3.4c-.3,0-4.4-3.4-10.6-6.6-3.1-1.3-5.3-2.2-7.5-2.8-1.9-.6-3.1-.6-3.8-.6s-3.8.9-5,1.3h0c.3,0,4.4-1.3,5-1.3,1.9,0,5,.3,11.6,3.4,3.4,1.6,6.3,3.4,7.8,4.4,1.9,1.3,2.8,2.2,2.8,2.2h0l2.5,3.8h-1.9l.3-.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.9,84.1h0s-5-.6-10.3-3.1c-1.6-.6-3.8-1.9-5.9-3.1-1.3-.9-1.9-1.3-1.9-1.3h0s2.2,2.2,7.5,4.4c5.3,2.5,10.3,2.8,10.3,2.8h0l.3.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.315c3d70bd410c048ba340664cb51f49.svg";
export { ForwardRef as ReactComponent };